import React from "react";
import styles from "./Destinations5.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations5 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Duplicate array for infinite scrolling
  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            Global <span>Escapes</span>
          </h2>
          <p className={styles.lead}>
            Hand-picked journeys for the modern traveler
          </p>
        </div>

        <div className={styles.trackWrapper}>
          <div className={styles.track}>
            {scrollItems.map((dest, index) => {

              const fallbackImage =
                fallbackImages[index % fallbackImages.length];

              const imageUrl =
                dest?.image && dest.image.trim() !== ""
                  ? dest.image
                  : fallbackImage;

              return (
                <div key={index} className={styles.card}>
                  <div className={styles.imageContainer}>
                    <img
                      src={imageUrl}
                      alt={dest?.name || "Destination"}
                      className={styles.image}
                      onError={(e) => {
                        e.target.src = fallbackImage;
                      }}
                    />

                    <div className={styles.indexNumber}>
                      {(index % destinations.length + 1)
                        .toString()
                        .padStart(2, "0")}
                    </div>
                  </div>

                  <div className={styles.info}>
                    <h3 className={styles.cardTitle}>
                      {dest?.name || "Explore Destination"}
                    </h3>

                    <div className={styles.exploreBtn}>
                      View Details
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Destinations5;